module.exports = __webpack_public_path__ + "media/books/ArtBooks-hero-crop-mobile-8814ff99.jpg";